/**
 * Created by Kevin Dench on 6/15/2016.
 */
/**
 * The first parameter of this method is the name of the service, the second parameter is an array of injectors that you will use for the module.
 */
/* @ngInject */
export default function DefinitionApiService($resource, __env) {
    'use strict';

    let filteredDefinitionParameter;

    return {
        storeFilteredDefinitionParameter: function (dp) {
            filteredDefinitionParameter = dp;
        },
        getFilteredDefinitionParameter: function () {
            return filteredDefinitionParameter;
        },
        getAllDefinitions: function (callBack) {
            // The object after the url, will produce a query string
            $resource(
                `${__env.intellidataApiUrl}definitions`,
                {container: 'default'}
            ).query(callBack);
        },
        getFormattedParameterValues: function (definitionId, parameterId, callBack, callBackError) {
            $resource(
                `${__env.intellidataApiUrl}definitions/:defId/definition-parameters/:paramId/formatted-values`,
                {defId: definitionId, paramId: parameterId}
            ).query(callBack, callBackError);
        },
        getAncestorsByDefinitionId: function (definitionId, callback) {
            $resource(
                `${__env.intellidataApiUrl}definitions/:id/ancestors`,
                {id: definitionId}
            ).query(callback);
        },
        getDefinitionByDefinitionId: function (definitionId, callback) {
            $resource(
                `${__env.intellidataApiUrl}definitions/:id`,
                {id: definitionId}
            ).get(callback);
        }
    };
}
